// 导入api接口模块
import home from './home'
// 导入采购单商品接口
import trolley from './shopping-troelly'
import {BASEURL_PRO,BASEURL_PRO2,BASEURL_PRO_GATEWAY,SERVICE_MANAGE} from '@/modules/http.js'
// 获取当前环境变量 true => 生产环境 false => 开发环境
const BASEURL = (process.env.NODE_ENV === 'prod') ? '/api' : '/api'
const BASEURL1 = (process.env.NODE_ENV === 'prod') ? '/apiFront' : '/apiFront'

export const api = {
  // 登录模块
  ...home(BASEURL),
  ...trolley(BASEURL),
  // vCode: `${BASEURL}/app/getCode`,//登录模块目前替换成新的
  vCode: `${BASEURL_PRO}/union/sms/sendValid`,//登录模块目前替换成新的

  // login: `${BASEURL}/app/login`,
  // login: `${BASEURL}/Mgr/User/UnionLogin`,
  // register:`${BASEURL}/Mgr/User/UnionRegister`,
  imgCode:`${BASEURL_PRO}/api/Mgr/Admin/Captcha`,
  login: `${BASEURL_PRO}/api/Mgr/User/UnionLogin`,
  loginPwd:`${BASEURL_PRO}/api/Mgr/User/UnionLoginPwd`,
  register: `${BASEURL_PRO}/api/Mgr/User/UnionRegister`,
  getEnterpriseList:`${BASEURL_PRO}/api/Mgr/EnterpriseType/GetTypeOptionList`,//获取企业类型列表
  enterpriseCheck: `${BASEURL_PRO}/api/Mgr/Enterprise/enterpriseCheck`,//提交企业认证
  editEnterprise:`${BASEURL_PRO}/api/Mgr/Enterprise/enterpriseChange`,//提交被拒绝修改后的企业认证信息
  enterprisePass:`${BASEURL_PRO}/api/Mgr/Enterprise/enterpriseConfirm`,//检查是否认证
  enterpriseGetData:`${BASEURL_PRO}/api/Mgr/Enterprise/verifyData`,//获取企业认证信息
  shopCheck: `${BASEURL_PRO}/api/Mgr/Enterprise/ShopCheck`, // 提交店铺信息
  checkState: `${BASEURL_PRO}/api/Mgr/Enterprise/GetShopInfo`, // 检查店铺申请状态
  supportArea: `${BASEURL_PRO_GATEWAY}${SERVICE_MANAGE}/app/common/supportArea`, // 店铺所有经营区域查询
  scopeList: `${BASEURL}/shopscopecheck/scopeList`, // 查询已开通业务
  scopeApply: `${BASEURL}/shopscopecheck/scopeApply`, // 业务申请
  getShopApply: `${BASEURL}/shopscopecheck/getShopApply`, // 业务申请
  editUserInfo: `${BASEURL_PRO}/api/Mgr/User/updateUser`, // 修改企业认证信息
  getUserInfo: `${BASEURL_PRO}/api/Mgr/User/getUser`, // 获取企业认证信息
  getShopInfoEn: `${BASEURL_PRO}/api/Mgr/Enterprise/Detail`, // 获取企业认证信息
  getProvinceList: `${BASEURL_PRO}/api/Mgr/region/getProvinceList`, // 获取省级信息
  getChildren: `${BASEURL_PRO}/api/Mgr/region/getChildren`, // 获取市区街道信息

  
  // getEntInfo:`${BASEURL_PRO}/api/Mgr/Enterprise/getUserEnterpriseInfo`,// 获取企业信息
  // 图片上传
  upload: `${BASEURL}/file/upload`,
  // 店铺模块
  getShopIndex: `${BASEURL}/shop/getIndex`, // 查询店铺首页
  getShopClassify: `${BASEURL}/shop/getShopClassify`, // 查询店铺分类
  getShopProducts: `${BASEURL}/shop/getShopProducts`, // 查询店铺商品
  getShopBanner: `${BASEURL}/shop/getShopBanner`, // 获取店铺banner
  getSeckill: `${BASEURL}/seckill/getIndex`, // 秒杀专区
  getDiscount: `${BASEURL}/discount/getIndex`, // 折扣专区
  getWork: `${BASEURL}/work/getIndex`, // 拼团专区
  // 我的评价模块
  getEvaluateList: `${BASEURL}/comment/getAll`, // 查询我的评价列表
  likes: `${BASEURL}/comment/like`, // 点赞
  getEvaluateData: `${BASEURL}/comment/getById`, // 查询评价内容
  // 首页模块
  getSearchProducts: `${BASEURL}/app/getSearchProducts`, // 搜索商品
  getShops: `${BASEURL}/shop/getShops`, // 搜索店铺
  // 分类模块
  getClaasifyProducts: `${BASEURL}/classify/getClaasifyProducts`, // 查询分类商品
  // 订单模块
  getOrderList: `${BASEURL}/order/getAll`, // 查询订单列表
  getOrderDetail: `${BASEURL}/order/getById`, // 查询订单详情

  
  getEnterpriseDetail: `${BASEURL_PRO}/api/Mgr/Enterprise/getUserEnterpriseInfo`, // 查询离线订单列表  
  getOfflineOrderList: `${BASEURL_PRO_GATEWAY}/platform-order/offlineOrder/getAll`, // 查询离线订单列表  
  getOffLineOrderDetail: `${BASEURL_PRO_GATEWAY}/platform-order/offlineOrder/getOne`, // 查询离线订单详情

  cancelOrder: `${BASEURL}/order/cancel`, // 取消订单
  confirm: `${BASEURL}/order/confirm`, // 确认收货
  deleteOrder: `${BASEURL}/order/delete`, // 删除订单
  getExpressSelect: `${BASEURL}/order/getExpressSelect`, // 选择物流公司查询
  returnExpress: `${BASEURL}/order/returnExpress`, // 填写退货物流单
  addComment: `${BASEURL}/order/addComment`, // 添加评论
  addToComment: `${BASEURL}/order/addToComment`, // 追加评论
  getDilevery: `${BASEURL}/order/getDilevery`, // 查询物流信息
  buyAgain: `${BASEURL}/cart/buyAgain`, // 再次购买
  getShare: `${BASEURL}work/getShare`, // 邀请拼团
  getInvite: `${BASEURL}/work/getInvite`, // 邀请拼团信息
  // 收货地址模块
  addressList: `${BASEURL}/receive/getAll`, // 收货地址管理查询
  selectAddress: `${BASEURL}/receive/getSelect`, // 选择收货地址查询
  changeAddress: `${BASEURL}/receive/getById`, // 修改收货地址查询
  delAddress: `${BASEURL}/receive/delete`, // 删除收货地址
  updateAddress: `${BASEURL}/receive/update`, // 修改收货地址
  newAddress: `${BASEURL}/receive/save`, // 添加收货地址
  // 优惠券模块
  getCoupons: `${BASEURL}/coupon/getCoupons`, // 优惠券列表
  getCouponList: `${BASEURL}/coupon/getCouponList`, // 优惠券列表不带分页
  takeCoupon: `${BASEURL}/coupon/takeCoupon`, // 领取优惠券
  getCouponProducts: `${BASEURL}/coupon/getCouponProducts`, // 优惠券商品列表查询
  // 个人信息模块
  getUser: `${BASEURL}/user/getUser`, // 个人系信息查询
  updatePassword: `${BASEURL}/user/updatePassword`, // 修改密码
  relievePhone: `${BASEURL}/user/relievePhone`, // 解除绑定手机号
  updatePhone: `${BASEURL}/user/updatePhone`, // 更换绑定手机号
  update: `${BASEURL}/user/update`, // 修改个人信息
  checkUser: `${BASEURL}/user/checkUser`, // 身份验证
  getSelfProblems: `${BASEURL}/user/getSelfProblems`, // 我的提问
  getSelfAnswers: `${BASEURL}/user/getSelfAnswers`, // 我的回答
  delProblem: `${BASEURL}/seckill/deleteProblem`, // 批量删除我的提问
  delAnswer: `${BASEURL}/seckill/deleteAnswer`, // 批量删除我的回答
  getFootprint: `${BASEURL}/footprint/getAll`, // 我的足迹
  delFootprint: `${BASEURL}/footprint/delete`, // 删除足迹
  getAllShop: `${BASEURL}/collect/getAllShop`, // 收藏店铺查询
  getAllProduct: `${BASEURL}/collect/getAllProduct`, // 收藏商品查询
  unfavorite: `${BASEURL}/collect/cancel`, // 取消收藏
  getSelfCount: `${BASEURL}/user/getSelfCount`, // 获取订单未读数
  getCurrency:`${BASEURL}/user/getGoldNum`,//我的咖币
  checkCurrency:`${BASEURL}/user/record4page`,//咖币记录

  // 商品模块
  getProDetail: `${BASEURL}/product/getById`, // 商品详情
  getProOption: `${BASEURL}/product/getProducts`, // 选择商品配置信息
  addCart: `${BASEURL}/cart/addCart`, // 加入采购单
  addCartGroup: `${BASEURL}/cart/addBatchCart`,
  getEvaluate: `${BASEURL}/comment/getProductAll`, // 商品评价
  collect: `${BASEURL}/collect/collect`, // 收藏商品/店铺
  getProblems: `${BASEURL}/seckill/getProblems`, // 查询商品问答
  addProblem: `${BASEURL}/seckill/addProblem`, // 提问
  addAnswer: `${BASEURL}/seckill/addAnswer`, // 回答
  // 结算模块
  getSettlement: `${BASEURL}/order/getSettlement`, // 加入采购单
  // 画布模块
  fileUpload: BASEURL + '/file/upload', // 文件上传
  getClassify: BASEURL + '/canvas/getClassify', // 查询分类层级
  getProducts: BASEURL + '/canvas/getProducts', // 选择商品查询
  getServProducts: BASEURL + '/serv/canvas/getProducts', // 选择商品查询
  getCanvas: BASEURL + '/canvas/getCanvas', // 读取画布
  // 支付模块
  getOrderCoupons: `${BASEURL}/order/getOrderCoupons`, // 结算列表优惠券
  orderSubmit: `${BASEURL}/order/submit`, // 结算列表优惠券
  pay: `${BASEURL}/order/pay`, // 支付
  getPayCode: `${BASEURL}/order/getUrl`, // 根据订单id获取收款码
  checkPay: `${BASEURL}/order/checkPay`, // 监听支付
  getWorkSettlement: `${BASEURL}/work/getSettlement`, // 拼团单结算查询
  applyForMoney: `${BASEURL}/customer/add`, // 申请账期
  checkApplyFor: `${BASEURL}/customer/check`, // 检查账期
  // 售后
  submit: `${BASEURL}/after/submit`, // 申请售后
  getReasonSelect: `${BASEURL}/after/getReasonSelect`, // 选择退款原因查询
  returnRefund: `${BASEURL}/after/returnRefund`, // 撤销退款
  returnGoods: `${BASEURL}/after/returnGoods`, // 撤销退货
  getPay: BASEURL + '/order/pay', // 支付处理业务
  getAfterSaleList: `${BASEURL}/after/getAll`, // 获取售后列表
  getAfterSaleDetail: `${BASEURL}/after/getById`, // 获取售后订单详情
  platform: `${BASEURL}/after/platform`, // 申请平台介入
  settled: `http://supply.shop.kansian.net`, // 商家入驻地址
  // settled: `http://localhost:8081/#/`, // 商家入驻地址
  // 消息模块
  noticeGetAll: `${BASEURL}/notice/getAll`, // 消息列表
  noticeDetails: `${BASEURL}/notice/getById`, // 消息详情
  getGongGaoAll: `${BASEURL}/notice/getGongGaoAll` ,// 公告列表
  channelList: `${BASEURL_PRO2}/front/getChannelList`,// 帮助中心频道列表
  channeData: `${BASEURL_PRO2}/front/getCategoryTree`,// 频道分类列表
  getArticle: `${BASEURL_PRO2}/front/getCategoryByIdArticleList`,// 分类文章

  //企业授信管理
  creditList: `${BASEURL}/credit/getAll`,//获取企业授信列表
  billList:`${BASEURL}/credit/billGetAll`,//账单明细
  shopList: `${BASEURL}/credit/productGetAll`,//授权商品列表
  paybackList: `${BASEURL}/credit/paybackGetAll`,//还款明细
  payBack:`${BASEURL}/pay/payBack`,//账期还款

  //收货单管理相关
  getReceiveList:`${BASEURL}/order/check/getAll`,//查询收货单
  getReceiveDetail:`${BASEURL}/order/check/getById`,//查询收货单详情
  receiveGoToPay:`${BASEURL}/order/check/goToPay`,//收货单账期付款补款
  receiveCheckOrder:`${BASEURL}/order/check/checkOrder`,//验收收货单

  //订单确认收货前置确认
  orderPreConfirm:`${BASEURL}/order/preConfirm`,//订单确认收货前置确认
  isSchool: `${BASEURL_PRO}/api/Mgr/Enterprise/getEntTypeAppOnly`,//确认是否是学校
  getShopEntInfo:`${BASEURL}/check/getById`,//获取店铺下的企业信息
}
export default api



// WEBPACK FOOTER //
// ./src/api/index.js